import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { EventsService } from 'src/app/services/events.service';

@Component({
  selector: 'app-cards-wrapper',
  templateUrl: './cards-wrapper.component.html',
  styleUrls: ['./cards-wrapper.component.scss'],
})
export class CardsWrapperComponent implements OnInit {
  eventCards: any[] = [];
  sessions!: any;
  dateString: string = '';
  currentPage: number = 1;

  constructor(
    private eventsService: EventsService,
    private router: Router,
    private datePipe: DatePipe
  ) { }

  ngOnInit(): void {
    this.eventsService.getEventsActive(this.currentPage).subscribe({
      next: (res) => {
        if (res?.success == true) {
          this.eventCards = res.data.data;
        }
      }
    });
  }

  redirectToEvent(idEvent: number) {
    this.eventsService.getEventById(idEvent).subscribe((res) => {
      let eventData = res.data;
      let now = new Date();
      this.sessions = eventData.sessions.find(
        (session: any) => session.active && new Date(session.start_date) >= now
      );
      if (
        eventData.start_date !== eventData.end_date) {
        this.router.navigate(['event/' + idEvent]);
      } else {
        var date = new Date(this.sessions.start_date);
        localStorage.setItem('dateEvent', String(date));

        this.dateString = this.datePipe.transform(date, 'dd MMMM y');

        localStorage.setItem('dateString', this.dateString);

        localStorage.setItem('selectedDateYear', String(date.getFullYear()));
        localStorage.setItem('selectedDateMonth', String(date.getMonth() + 1));
        localStorage.setItem('selectedDateDay', String(date.getDate()));

        localStorage.setItem('numDaySelect', String(date.getDay()));
        localStorage.setItem('dateDaySelect', String(date.getDate()));

        this.router.navigate(['event/tickets/' + idEvent]);
      }
    });

    this.router.navigate(['event/' + idEvent]);
  }
}
